import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ViveroGrupoEspecie } from './entity-viveros-grupo-especie.model';

import { Error } from '@rpe/registro-personas-empresas-lib';
// LOAD
export const entityViverosGrupoEspecieLoadRequest = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Load Request'
);

export const entityViverosGrupoEspecieLoadFailure = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Load Failure',
  props<{ error: Error }>()
);

export const entityViverosGrupoEspecieLoadSuccess = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Load Success',
  props<{ items: ViveroGrupoEspecie[] }>()
);

// ADD
export const entityViverosGrupoEspecieAddRequest = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Add Request',
  props<{ item: ViveroGrupoEspecie[] }>()
);

export const entityViverosGrupoEspecieAddFailure = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Add Failure',
  props<{ error: Error }>()
);

export const entityViverosGrupoEspecieAddSuccess = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Add Success',
  props<{ item: ViveroGrupoEspecie[] }>()
);

// CHANGE
export const entityViverosGrupoEspecieChangeRequest = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Change Request',
  props<{ item: ViveroGrupoEspecie[] }>()
);

export const entityViverosGrupoEspecieChangeFailure = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Change Failure',
  props<{ error: Error }>()
);

export const entityViverosGrupoEspecieChangeSuccess = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Change Success',
  props<{ item: ViveroGrupoEspecie[] }>()
);

// DELETE
export const entityViverosGrupoEspecieDeleteRequest = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Delete Request',
  props<{ item: ViveroGrupoEspecie }>()
);

export const entityViverosGrupoEspecieDeleteFailure = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Delete Failure',
  props<{ error: Error }>()
);

export const entityViverosGrupoEspecieDeleteSuccess = createAction(
  '[ENTITYVIVEROSGRUPOESPECIE] Delete Success',
  props<{ item: ViveroGrupoEspecie }>()
);
